module.exports = __webpack_public_path__ + "img/fancy.1f93f04.jpg";